// @ts-nocheck
import React from "react";
import { ChevronDown, Eye } from "lucide-react";
import {
  Card,
  CardHeader,
  CardTitle,
  CardContent,
  Button,
} from "@/components/ui";
import { OrderStatusBadge } from "./OrderStatusBadge";
import { fmtDateShort } from "./sellerDetail.utils";

export const OrdersTab = ({
  orders,
  orderFilter,
  onFilterChange,
  onViewOrder,
}) => (
  <Card>
    <CardHeader>
      <div className="flex items-center justify-between">
        <CardTitle className="text-base">Orders</CardTitle>
        <div className="relative">
          <select
            data-testid="order-status-filter"
            value={orderFilter}
            onChange={(e) => onFilterChange(e.target.value)}
            className="appearance-none pl-3 pr-8 py-1.5 text-xs rounded-md bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 text-slate-900 dark:text-slate-100 focus:outline-none"
          >
            {["All", "Processing", "Shipped", "Delivered", "Returned"].map(
              (s) => (
                <option key={s}>{s}</option>
              ),
            )}
          </select>
          <ChevronDown className="absolute right-2 top-1/2 -translate-y-1/2 w-3.5 h-3.5 text-slate-400 pointer-events-none" />
        </div>
      </div>
    </CardHeader>
    <CardContent className="p-0">
      <table data-testid="orders-table" className="w-full text-sm">
        <thead>
          <tr className="border-b border-slate-200 dark:border-slate-700">
            {[
              "Order ID",
              "Product",
              "Marketplace",
              "Qty",
              "Amount",
              "Status",
              "Date",
              "",
            ].map((h, i) => (
              <th
                key={i}
                className="px-4 py-2.5 text-left text-xs font-semibold uppercase tracking-wider text-slate-500 dark:text-slate-400"
              >
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-slate-100 dark:divide-slate-800">
          {orders.map((o) => (
            <tr
              key={o.id}
              data-testid={`order-row-${o.id}`}
              className="hover:bg-slate-50 dark:hover:bg-slate-800/50"
            >
              <td className="px-4 py-2.5 font-mono text-xs text-indigo-600 dark:text-indigo-400">
                {o.id}
              </td>
              <td className="px-4 py-2.5 text-slate-900 dark:text-slate-100">
                {o.product}
              </td>
              <td className="px-4 py-2.5 text-slate-500 dark:text-slate-400">
                {o.marketplace}
              </td>
              <td className="px-4 py-2.5 text-slate-700 dark:text-slate-300">
                {o.qty}
              </td>
              <td className="px-4 py-2.5 font-medium text-slate-900 dark:text-slate-100">
                ${o.amount.toLocaleString()}
              </td>
              <td className="px-4 py-2.5">
                <OrderStatusBadge status={o.status} />
              </td>
              <td className="px-4 py-2.5 text-xs text-slate-500 dark:text-slate-400">
                {fmtDateShort(o.date)}
              </td>
              <td className="px-4 py-2.5">
                <Button
                  variant="ghost"
                  size="sm"
                  data-testid={`view-order-${o.id}`}
                  onClick={() => onViewOrder(o.id)}
                >
                  <Eye className="w-3.5 h-3.5" />
                </Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </CardContent>
  </Card>
);
